
import { Component, Vue } from "vue-property-decorator";
import { getAPIAuthorizedHeader } from "@/services/common";
import Axios from "axios";
import { API_STORE } from "@/config";
import AsyncPageLoader from "@/views/AsyncPageLoader.vue";
import DatePicker from "vuejs-datepicker";

@Component({ components: { AsyncPageLoader, DatePicker } })
export default class SysTemUpdateComponent extends Vue {
  public asyncPageLoader = false;
  public disableSubmitbutton = false;
  public config = {
    disabledDates: {
      to: new Date(new Date().setDate(new Date().getDate() - 1)), // Disable all dates up to specific date
    },
  };
  public systemUpdates = {
    text: null,
    validUpto: null,
  };
  public previousUpdates = {
    text: null,
    validUpto: null,
  };

  public async getSystemUpdates() {
    this.asyncPageLoader = true;
    let response = await Axios.get(API_STORE.PORTAL + "getSystemUpdates", {
      params: { subdomain: this.$client ? this.$client.subdomain : null },
      headers: getAPIAuthorizedHeader(),
    });
    this.asyncPageLoader = false;
    if (response && response.data) {
      this.previousUpdates = JSON.parse(JSON.stringify(response.data));
      this.systemUpdates = JSON.parse(JSON.stringify(response.data));
    }
  }

  public async postSystemUpdates() {
    let valid = await this.$validator.validateAll();
    let updatesAvail = this.systemUpdates.text != this.previousUpdates.text;
    if (valid && !updatesAvail)
      this.$snotify.error("Updates must be different from previous updates");

    if (valid && updatesAvail) {
      this.disableSubmitbutton = true;
      this.$showLoader(true);
      this.systemUpdates["subdomain"] = this.$client
        ? this.$client.subdomain
        : null;
      let response = await Axios.post(
        API_STORE.PORTAL + "postSystemUpdates",
        this.systemUpdates,
        {
          headers: getAPIAuthorizedHeader(),
        }
      );
      this.disableSubmitbutton = false;
      this.$showLoader(false);
      if (response) {
        this.$snotify.success(response.data.message);
        this.getSystemUpdates();
      }
    }
  }

  mounted() {
    this.getSystemUpdates();
  }
}
